"use client";

import { gql, useMutation } from "@apollo/client";
import { useEffect } from "react";
import useClientCart from "./useClientCart";

const CreateClientCartMutation = gql`
  mutation CreateClientCart($clientId: ID!) {
    createClientCart(clientId: $clientId) {
      _id
    }
  }
`;

const useEnsureClientHasCart = (clientId) => {
  const { cart, error, loading } = useClientCart(clientId);
  const [createClientCart] = useMutation(CreateClientCartMutation);

  useEffect(() => {
    if (!cart && !loading && !error && clientId) {
      createClientCart({
        variables: { clientId },
        refetchQueries: ["ClientCart"],
        awaitRefetchQueries: true,
      });
    }
  }, [cart, loading, error, clientId]);

  return { orderId: cart?._id };
};

export default useEnsureClientHasCart;
